import { createSlice } from "@reduxjs/toolkit";
import { deployementsListsApis } from "./deployementsActions";

const initialState = {
  deployementsListsData: [], 
  status: "idle",
  error: null,
};

const deployementsSlice = createSlice({
  name: "deployements",
  initialState,
  reducers: {
    logout(state) {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Deployments List
      .addCase(deployementsListsApis.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(deployementsListsApis.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.deployementsListsData = action.payload?.data || action.payload;
      })
      .addCase(deployementsListsApis.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error.message;
      });
  },
});

export default deployementsSlice.reducer;